function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lyriq-AI",
  transform: "translate(-294.000000, -309.000000)",
  fill: "#211D1A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lyric-Icon",
  transform: "translate(294.000000, 309.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,12.5 C0,5.5965 5.43103826,0 12.1304348,0 L173.869565,0 C180.5688,0 186,5.5965 186,12.5 C186,19.4035 180.5688,25 173.869565,25 L12.1304348,25 C5.43103826,25 0,19.4035 0,12.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.44,12.3648649 C210.44,5.5359973 215.893392,0 222.62,0 C274.191744,0 316,42.4421514 316,94.7972973 C316,101.626165 310.546608,107.162162 303.82,107.162162 C297.093392,107.162162 291.64,101.626165 291.64,94.7972973 C291.64,60.3191081 267.10948,31.6573514 234.8,25.8173432 L234.8,234.932432 C234.8,235.80127 234.712304,236.648676 234.543408,237.466405 C234.713928,239.347514 234.8,241.251703 234.8,243.175676 C234.8,277.320838 207.534664,305 173.9,305 C140.265336,305 113,277.320838 113,243.175676 C113,209.030514 140.265336,181.351351 173.9,181.351351 C187.609808,181.351351 200.262392,185.951081 210.44,193.71127 L210.44,12.3648649 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1304348,49 C5.43103826,49 0,54.5965 0,61.5 C0,68.4035 5.43103826,74 12.1304348,74 L173.869565,74 C180.5688,74 186,68.4035 186,61.5 C186,54.5965 180.5688,49 173.869565,49 L12.1304348,49 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,111.5 C0,104.5965 5.47596,99 12.2307692,99 L93.7692308,99 C100.52404,99 106,104.5965 106,111.5 C106,118.403333 100.52404,124 93.7692308,124 L12.2307692,124 C5.47596,124 0,118.403333 0,111.5 Z",
  id: "Path"
}))));

var SvgIconLyricAi = function SvgIconLyricAi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 305,
    viewBox: "0 0 316 305",
    fill: "#000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLyricAi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_lyric_ai.9d641d92.svg";
export { ForwardRef as ReactComponent };